import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'react-bootstrap';
import { resolveAssetUrl } from '../../../../../modules/assets';
import styles from './SimpleHeroSlideShow.scss';

export const OVERLAY_NONE = 'OVERLAY_NONE';
export const PARTIAL_OVERLAY = 'PARTIAL_OVERLAY';
export const FULL_OVERLAY = 'FULL_OVERLAY';

export const title = 'Style';
export default class HeroStylesInput extends React.Component {
  static propTypes = {
    input: PropTypes.shape({
      value: PropTypes.string,
      onChange: PropTypes.func.isRequired,
    }),
  };

  handleClickFullOverlay = () => {
    this.props.input.onChange(FULL_OVERLAY);
  };

  handleClickPartialOverlay = () => {
    this.props.input.onChange(PARTIAL_OVERLAY);
  };

  handleClickOverlayNone = () => {
    this.props.input.onChange(OVERLAY_NONE);
  };

  render() {
    const { input } = this.props;
    return (
      <Row>
        <div className={styles.description}>Select the style of hero image you want</div>
        <Col
          xs={4}
          className={input.value === FULL_OVERLAY ? '' : styles.nonSelected}
          onClick={this.handleClickFullOverlay}
        >
          <div>
            <img
              alt="full-overlay"
              src={resolveAssetUrl('/img/full-overlay.jpg')}
              height={100}
              width={175}
            />
          </div>
          <div className={styles.styleOption}>Full Overlay</div>
        </Col>
        <Col
          xs={4}
          className={input.value === PARTIAL_OVERLAY ? '' : styles.nonSelected}
          onClick={this.handleClickPartialOverlay}
        >
          <div>
            <img
              alt="overlay-behind-content"
              src={resolveAssetUrl('/img/overlay-behind-content.jpg')}
              height={100}
              width={175}
            />
          </div>
          <div className={styles.styleOption}>Overlay behind content area</div>
        </Col>
        <Col
          xs={4}
          className={input.value === OVERLAY_NONE ? '' : styles.nonSelected}
          onClick={this.handleClickOverlayNone}
        >
          <div>
            <img
              alt="no-overlay"
              src={resolveAssetUrl('/img/no-overlay.jpg')}
              height={100}
              width={175}
            />
          </div>
          <div className={styles.styleOption}>No Overlay</div>
        </Col>
      </Row>
    );
  }
}
